module.exports = __webpack_public_path__ + "static/media/Alex O'Connor.1d429134.png";